export default __webpack_public_path__ + "static/media/green_check_1.8bed7e96.png";